import { render } from "./ConfirmBooking.vue?vue&type=template&id=7d4b9f50"
import script from "./ConfirmBooking.vue?vue&type=script&lang=js"
export * from "./ConfirmBooking.vue?vue&type=script&lang=js"

import exportComponent from "/builds/nordhealth/projects/therapy/easypractice/system/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__